<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :color="secondary_color"
          v-bind="attrs"
          v-on="on"
        >
          <span class="textcolor" :style="'--p-tertiary_color: ' + tertiary_color">
            NOVO CMS
          </span>
        </v-btn>
      </template>
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <div class="d-flex justify-space-between align-center">
                  <span class="headline grey--text text--darken-4">Novo CMS</span>
                  <v-icon size="24px" class="pointer" @click="dialog = false">
                    mdi-close
                  </v-icon>
                </div>
              </v-col>
            </v-row>
             <v-form
              ref="form"
              v-model="valid"
            >
              <v-row>
                <v-col cols="12">
                  <v-text-field label="Nome do CMS" v-model="name" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field label="ID do CMS (Content Owner ID)" v-model="cmsIdYoutube" :rules="[rules.required]"></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn
              :disabled="!valid"
              color="#fed602"
              class="button-primary mr-4"
              @click="createCms()"
            >
              <v-progress-circular v-if="loading" :indeterminate="true" size="24"></v-progress-circular>
              <span v-else>Salvar</span>
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { getClientColorByKey } from '../utils/clientColor.js'

  export default {
    data: () => ({
      primary_color: getClientColorByKey("primary_color"),
      secondary_color: getClientColorByKey("secondary_color"),
      tertiary_color: getClientColorByKey("tertiary_color"),
      name: '',
      cmsIdYoutube: '',
      loading: false,
      notification: {
          active: false,
          description: '',
          type: '',
          closeText: ''
      },
      valid: true,
      rules: {
          required: value => !!value || 'Este campo é obrigatório.',
          min: v => v.length >= 6 || 'Sua senha precisa ter pelo menos 6 caracteres',
          email: v => /.+@.+\..+/.test(v) || 'E-mail inválido'
      },
      dialog: false
    }),
    methods: {
      createCms() {
        this.$http.post( '/cms', {
          name: this.name,
          cms_id_youtube: this.cmsIdYoutube
        })
        .then( () => {
          this.notification = {
            active: true,
            description: 'CMS criado com sucesso.',
            type: 'success',
            closeText: 'Fechar'
          },
          this.$emit( 'notification', this.notification );
        } ).catch( () => {
          this.notification = {
            active: true,
            description: 'Houve um erro ao cadastrar o CMS, tente novamente.',
            type: 'error',
            closeText: 'Fechar'
          },
          this.$emit( 'notification', this.notification );
        }) .finally(() => {
          this.loading = false,
          this.valid = true,
          this.dialog = false,
          this.reset();
          this.$emit("getData")
        })
      },
      reset () {
        this.$refs.form.reset()
      }
    }
  }
</script>
<style scoped>
  .textcolor {
    color: var(--p-tertiary_color);
  }
</style>